// Plug necessary events between new and legacy scripts
import events from "/events";

events.on("authenticate_data_ready", config => {
  events.emitNoLegacy("setup:ready", config);
  events.emitNoLegacy("abtest:ready", config.test_categories);
});
